import React from 'react'
import PropTypes from 'prop-types'

import Loading from '../components/loading'
import request from '../util/request'
import StateChart from '../components/state-chart'
import states from '../util/states'

class StateChange extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
    }
  }

  componentWillMount() {
    const { state } = this.props
    const { data } = this.state
    /* istanbul ignore next */
    if (!data[`change/${state}`]) {
      this.loadJSON(`change/${state}`)
    }
  }

  /* istanbul ignore next */
  componentWillReceiveProps(nextProps) {
    const { state } = nextProps
    const { data } = this.state
    if (!data[`change/${state}`]) {
      this.loadJSON(`change/${state}`)
    }
  }

  async loadJSON(name) {
    const newData = await request(`/data/${name}.json`)
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [name]: newData,
      },
    }))
  }

  render() {
    const { state } = this.props
    const { data } = this.state
    if (!data[`change/${state}`]) {
      return (<Loading message={`Loading ${states[state]}...`} />)
    }
    const changeData = data[`change/${state}`]
    const labels = {
      '-2': `Greatly Worsened: ${changeData[-2] ? changeData[-2].length : "0"}`,
      '-1': `Worsened: ${changeData[-1] ? changeData[-1].length : "0"}`,
      0: `Little or No Change: ${changeData[0] ? changeData[0].length : "0"}`,
      1: `Improved: ${changeData[1] ? changeData[1].length : "0"}`,
      2: `Greatly Improved: ${changeData[2] ? changeData[2].length : "0"}`,
    }
    const labels2 = {
      '0' : 0,
      '1' : 0,
      '2' : 0,
    }
    const columns2 = {
      '0' : 0,
      '1' : changeData[0] ? changeData[0].length : 0,
      '2' : 0,
    }
    if(changeData[-2]) {
      labels2['0'] += changeData[-2].length;
      columns2['0'] += changeData[-2].length;
    }
    if(changeData[-1]) {
      labels2['0'] += changeData[-1].length;
      columns2['0'] += changeData[-1].length;
    }
    if(changeData[2]) {
      labels2['2'] += changeData[2].length;
      columns2['2'] += changeData[2].length;
    }
    if(changeData[1]) {
      labels2['2'] += changeData[1].length;
      columns2['2'] += changeData[1].length;
    }
    labels2['0'] = `Worsened: ${labels2[0]}`;
    labels2['1'] = `Little or No Change: ${changeData[0] ? changeData[0].length : "0"}`;
    labels2['2'] = `Improved: ${labels2[2]}`;

    

    const chart = {
      data: {
        type: 'donut',
        columns: [
          ['2', columns2['2']],
          ['1', columns2['1']],
          ['0', columns2['0']],
        ],
        colors: {
          2: '#4ABDBC',
          1: '#CBCCCF',
          0: '#F47920',
        },
        names: labels2,
        order: null,
        // order: /* istanbul ignore next */ (a, b) => (parseInt(a.id, 10) > parseInt(b.id, 10)),
      },
      tooltip: {
        show: true,
        format: {
          value: /* istanbul ignore next */ (_, ratio) => `(${(ratio * 100).toFixed(2)}%)`,
        },
        contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
          var name = d[0].name;
          var value = d[0].value;
          var ratio = d[0].ratio;
          var id = d[0].id;
          var tooltip__text = "";
              tooltip__text += "<div class='chart__tooltip' style='border-color: " + chart.data.colors[id] + ";'>";
              tooltip__text += "<h3 class='chart__tooltip__title'>";
              tooltip__text += name.split(": ")[0];
              tooltip__text += "</h3>";
              tooltip__text += "<p class='chart__tooltip__value'>";
              tooltip__text += value;
              tooltip__text += "</p>";
              tooltip__text += "</div>";
          return tooltip__text;
        },
      },
      donut: {
        label: {
          show: false,
        },
      },
      legend: {
        show: false,
        item: {
          // Prevent default click action of removing slice.
          onclick: /* istanbul ignore next */ () => null,
        },
      },
    }
    return (
      <StateChart stateName={states[state]} chart={chart} labels={labels2} />
    )
  }
}

StateChange.propTypes = {
  state: PropTypes.string.isRequired,
}

export default StateChange



// WEBPACK FOOTER //
// ./src/components/Visualizations/containers/state-change.jsx